import React from "react";
import * as Mui from "@mui/material";
import { useTheme } from "@mui/material/styles";
import * as Icons from "react-feather";

interface AddAnotherButtonProps {
	onClick: () => void;
	disabled?: boolean;
}

export const AddAnotherButton: React.FC<AddAnotherButtonProps> = ({
	onClick,
	disabled = false,
}) => {
	const theme = useTheme();
	return (
		<Mui.Button
			onClick={onClick}
			disabled={disabled}
			style={{
				height: 32,
				padding: "4px 0",
				textTransform: "none",
				backgroundColor: "transparent",
				color: theme.palette.primary.main,
				fontFamily: theme.typography.fontFamily,
				fontWeight: 500,
				fontSize: 16,
				lineHeight: "20px",
			}}
			startIcon={
				<Icons.Plus
					size={16}
					style={{
						strokeWidth: 2,
					}}
				/>
			}
		>
			Add Another
		</Mui.Button>
	);
};
